import { render } from "./AITab.vue?vue&type=template&id=d43f5f10&scoped=true"
import script from "./AITab.vue?vue&type=script&lang=js"
export * from "./AITab.vue?vue&type=script&lang=js"

import "./AITab.vue?vue&type=style&index=0&id=d43f5f10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d43f5f10"]])

export default __exports__